// extracted by mini-css-extract-plugin
export var card = "_t4-0";
export var details = "_t4-1";